
class RoNewsletter extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.subscribe_btn');
    this.form = this.querySelector('form');
    this.email = this.querySelector('input[name="email"]');
    this.input = this.querySelectorAll('.error-message');
    this.birth = this.querySelector('input[name="dob"]');
    this.first_name = this.querySelector('input[name="first_name"]');
    this.last_name = this.querySelector('input[name="last_name"]');
    this.country = this.querySelector('select[name="country"]');
    this.open_tracking = this.querySelector('input[name="open_tracking"]');
    this.error_notification = this.querySelector(".notification-error");
    this.list_id = this.dataset.id;
    this.public_key = this.dataset.publicKey;
    this.check_error = this.dataset.check_error;
    this.error_msg = this.dataset.error;
    this.success_msg = this.dataset.success;
    this.addEvents();
  }

  addEvents() {
    let self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.buildData();
    });
  }


  async buildData() {
    let self = this;
    // The client subscriptions API also sets the email open and click tracking consent
    const url = `https://a.klaviyo.com/client/subscriptions?company_id=${this.public_key}`;
    const method = "POST";

    const emailSubscriptions = {
      "marketing": { "consent": "SUBSCRIBED" },
    };

    if (this.open_tracking.checked) {
      emailSubscriptions.open_tracking = { "consent": "SUBSCRIBED" };
      emailSubscriptions.click_tracking = { "consent": "SUBSCRIBED" };
    }

    const data = {
      "data": {
        "type": "subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": this.email.value,
                "first_name": this.first_name.value,
                "last_name": this.last_name.value,
                "properties": {
                  "$birth": this.birth.value,
                  "$country": this.country.value,
                  "open_tracking": this.open_tracking.checked,
                },
                "subscriptions": {
                  "email": emailSubscriptions,
                },
              },
            },
          },
        },
        "relationships": {
          "list": {
            "data": { "type": "list", "id": this.list_id },
          },
        },
      },
    };

    const options = {
      method,
      headers: {
        "Content-Type": "application/vnd.api+json",
        "revision": "2026-10-15",
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(url, options);

      if (response.ok) {
        self.button.innerText = this.success_msg;
        self.button.classList.add('success');
      } else {
        const responseData = await response.json().catch(() => ({}));
        console.error("Error while subscribing", responseData.errors);
        self.error_notification.innerText = this.error_msg;
      }
    } catch (error) {
      console.error("Exception while subscribing", error);
      self.error_notification.innerText = this.error_msg;
    }
  }
}

customElements.define("ro-newsletter", RoNewsletter);
